<template>
    <div class="participant-create mb-3 mt-page">

        <data-form :title="$i18n.gt('HEADING_CREATE_PATIENT')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="participantFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancel-route="successRoute"
                   :submit-success-message="$i18n.gt('LABEL_PATIENT_CREATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_CREATING_PATIENT')"
                   :submit-success-route="successRoute">
            <template v-slot:labelSlot="slotProps">
                <emr-lookup-participant-modal v-if="emrWriteEnabled"
                                              :fieldModel="slotProps.fieldModel"
                                              :form="slotProps.form"/>
            </template>
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import ParticipantFields from '@/models/Participant'

/**
 * Page to create a Participant
 */
export default Vue.extend({
    name: 'ParticipantCreate',
    data() {
        return {
            participantFields: ParticipantFields,
            // NB: don't show contact_privacy_waived (only allow patient to edit this in profile)
            fieldGroups: [
                ['firstname', 'lastname', 'dob', 'gender', 'gender_identity', 'pronouns', 'sexual_orientation', 'ethnicity'],
                ['email', 'phone_primary', 'phone_secondary', 'preferred_contact_method'],
                ['plan_id', 'external_id', 'emr_id', 'address', 'address2', 'city', 'state', 'zip', 'disabled'],
            ],
            emrWriteEnabled: false,
        }
    },
    computed: {
        successRoute() {
            if (this.$user.practitionerId()) {
                return '/'
            } else {
                return '/participant/admin'
            }
        },
    },
    mounted() {
        this.$api.emrScope(this, {
            practice: this.$user.practitionerPracticeId()
        })
            .then((scope) => {
                if (scope) {
                    this.emrWriteEnabled = scope.includes('patient.write')
                }
            })
    },
    methods: {
        loadModelInstance() {
            return new Promise((resolve, reject) => {
                const participant = {}
                if (this.$user.practitionerPracticeId()) {
                    participant.practice_id = this.$user.practitionerPracticeId()
                }
                resolve(participant)
            })
        },
        onSubmit(modelInstance) {
            return this.$api.createItem(this, 'participant', modelInstance)
        }
    }
})

</script>
